import { ajax } from "../../../../../plugins/api";

export const payments = {
    acts: {
        getAct: actId => ajax.get(`accounting/acts/${actId}`),
        getActs: (status = null, page = 1) => ajax.get(`accounting/acts`, { status, page }),
        changeActStatus: (actId, status = "pending") => ajax.put(`accounting/acts/${actId}`, status)
        // list: data => ajax.get(`accounting/acts`, data),
        // get: id => ajax.get(`accounting/acts/${id}`),
        // updateStatus: (id, data, vmId = null, scope = "form") => ajax.put(`accounting/acts/${id}`, data, vmId, scope)
    },
    documents: {
        changeContractStatus: (contractId, data) => ajax.put(`accounting/contracts/${contractId}`, data),
        getContract: contractId => ajax.get(`accounting/contracts/${contractId}`),
        getContracts: (status = null, page = 1) => ajax.get(`accounting/contracts`, { status, page })
        // list: data => ajax.get(`accounting/contracts`, data),
        // get: id => ajax.get(`accounting/contracts/${id}`),
        // updateStatus: (id, data, vmId = null, scope = "form") =>
        //     ajax.put(`accounting/contracts/${id}`, data, vmId, scope)
    }
};
